import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStateStudyPayment, IStudyPaymentPayload } from "../types";
import { IEntityWithIDTranslations } from "../../../../types";
import { GetDeleteStudyPayment, GetStudyPayment } from "../store/thunk";

const initialState: IInitialStateStudyPayment = {
    selectedStudyPaymentIDs: [],
    isLoadingStudyPayment: true,
    isViewStudyPaymentRestore: false,
    studyPaymentTypes: [],
    studyPayment: [],
    studyPaymentRestore: [],
};

const studyPaymentSlice = createSlice({
    name: "studyPayment",
    initialState,
    reducers: {
        setStudyPaymentTypes(
            state,
            action: PayloadAction<{
                data: IEntityWithIDTranslations[];
                defaultLanguage: string;
            }>
        ) {
            const { data, defaultLanguage } = action.payload;
            state.studyPaymentTypes = data.flatMap(data =>
                data.translations
                    .filter(elem => elem.slug === defaultLanguage && elem.name)
                    .map(elem => ({
                        id: data.id,
                        abbreviation: elem?.abbreviation || "",
                        name: elem.name as string,
                    }))
            );
        },

        setStudyPayment: (state, action: PayloadAction<{ data: IStudyPaymentPayload[] }>) => {
            const { data } = action.payload;
            state.studyPayment = data;
        },
        setIsViewStudyPaymentRestore: state => {
            state.isViewStudyPaymentRestore = !state.isViewStudyPaymentRestore;
        },
        setSelectedStudyPaymentIDs: (state, action) => {
            state.selectedStudyPaymentIDs = action.payload;
        },
        updateStudyPayment: (state, action) => {
            const { id, ...rest } = action.payload;
            state.studyPayment = state.studyPayment.map(elem => (elem.id === id ? { ...elem, ...rest } : elem));
        },
        deletedStudyPayment: (state, action: PayloadAction<number>) => {
            state.studyPayment = state.studyPayment.filter(elem => elem.id !== action.payload);
        },
        setStudyPaymentRestore: (state, action) => {
            state.studyPaymentRestore = action.payload;
        },
        deletedRestoreStudyPayment: (state, action) => {
            state.studyPaymentRestore = state.studyPaymentRestore.filter(elem => elem.id !== action.payload);
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetStudyPayment.pending, state => {
                state.isLoadingStudyPayment = true;
            })
            .addCase(GetStudyPayment.fulfilled, state => {
                state.isLoadingStudyPayment = false;
            })
            .addCase(GetStudyPayment.rejected, state => {
                state.isLoadingStudyPayment = false;
            })
            .addCase(GetDeleteStudyPayment.pending, state => {
                state.isLoadingStudyPayment = true;
            })
            .addCase(GetDeleteStudyPayment.fulfilled, state => {
                state.isLoadingStudyPayment = false;
            })
            .addCase(GetDeleteStudyPayment.rejected, state => {
                state.isLoadingStudyPayment = false;
            });
    },
});

export const {
    setIsViewStudyPaymentRestore,
    setSelectedStudyPaymentIDs,
    setStudyPaymentTypes,
    setStudyPayment,
    updateStudyPayment,
    deletedStudyPayment,
    setStudyPaymentRestore,
    deletedRestoreStudyPayment,
} = studyPaymentSlice.actions;

export default studyPaymentSlice;
